import get from 'lodash/get';
import { useAuth } from '@hummingbirdtechgroup/wings-auth';

const useLastLogin = () => {
  const { user } = useAuth();
  return new Date(get(user, 'last_login', ''));
};

export default useLastLogin;
